import { FormControl, Select, InputLabel, MenuItem, SelectChangeEvent, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { apiStore } from "../../api/ApiFactory";
import CardList from "./CardList";
import ChartIndex from "./Charts/ChartIndex";

//To Do: Get rid of the hardcoded years and come up with a solution to get years and set default.

const Dashboard = () => {
    const [year, setYear] = React.useState("2026");

    const removeBreadcrumb = ()=>{
        const header = document.querySelector(".header-label-container") as HTMLDivElement;
        header.style.display = "none";
    }

    const addBreadcrumb = ()=>{
        const header = document.querySelector(".header-label-container") as HTMLDivElement;
        header.style.display = "block";
    }

    useEffect(() => {
        apiStore.dashboardApi.getDashboardData(Number(year));
        removeBreadcrumb()
        return ()=>{
            addBreadcrumb();
        }
    }, [year])

    const handleChange = (event: SelectChangeEvent) => {
        setYear(event.target.value as string);
    };

    return (
        <div className="dashboard-container">
            <section className="model-year">
                <Stack direction="row" mb={4} justifyContent="space-between" alignItems="center">
                    <Typography  className="page-title">Dashboard</Typography>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <InputLabel >
                           Year
                        </InputLabel>
                        <FormControl sx={{ width: "150px" }}>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={year}
                                onChange={handleChange}
                                size="small"
                            >
                                <MenuItem disabled><em>Year</em></MenuItem>
                                <MenuItem value={2026}>2026</MenuItem>
                                <MenuItem value={2025}>2025</MenuItem>
                                <MenuItem value={2024}>2024</MenuItem>
                                <MenuItem value={2023}>2023</MenuItem>

                            </Select>
                        </FormControl>
                    </Stack>
                </Stack>
            </section>
            <section className="card-list-section">
                <CardList />
            </section>
            <section className="report">
                <ChartIndex />
            </section>
        </div>
    )
}

export default Dashboard;